import axios from "axios";

export const onlyDigits = value => (value ?? '').toString().replace(/\D/g, '');

export const isCompleteZipCode = value => onlyDigits(value).length === 8;

/**
 * Endereço do ViaCEP, ou `null` quando o CEP não existe ou o serviço falha.
 *
 * Devolve só os campos que vieram preenchidos: CEP de logradouro único não
 * traz rua nem bairro, e sobrescrever o que já estava no formulário com string
 * vazia apagaria informação boa.
 *
 * Fora daqui, quem chama precisa garantir que a consulta só acontece quando o
 * CEP MUDA. Consultar a cada render (ou no carregamento do registro) atropela
 * o endereço que o usuário ajustou à mão — é o caso de CEP genérico de cidade
 * e o de logradouro que mudou de nome.
 */
export const fetchAddressByZipCode = async zipCode => {
    if (!isCompleteZipCode(zipCode)) return null;

    try {
        const { data } = await axios.get(`https://viacep.com.br/ws/${onlyDigits(zipCode)}/json/`);

        if (!data || data.erro) return null;

        const address = {
            street: data.logradouro,
            district: data.bairro,
            city: data.localidade,
            state: data.uf,
        };

        return Object.fromEntries(
            Object.entries(address).filter(([, value]) => !!value)
        );
    } catch (error) {
        return null;
    }
};
